/* global __webpack_public_path__:true */
/* exported __webpack_public_path__ */

// Set the webpack public path for loading lazy chunks.
//
// With publicPath: "auto" in webpack config, webpack infers the path from the
// script src. However, Rails serves assets at /assets/ regardless of the
// original webpack-dev-server port, so we always set the path explicitly.
//
// This ensures lazy-loaded chunks work from any origin (localhost:3500 for
// local development, or buildkite.test:3000 for Selenium tests) since
// writeToDisk: true makes them available via Rails at /assets/.
//
// In production, window._frontendPublicPath points to the CDN.
// In development/test, it falls back to /assets/.
//
// Must be done in a module so that it is executed before all other imports.
// See https://webpack.js.org/guides/public-path/#on-the-fly
if (window._frontendPublicPath) {
  __webpack_public_path__ = window._frontendPublicPath;
} else {
  __webpack_public_path__ = "/assets/";
}
